import { useI18n } from "../i18n";

export type ScanCtaError =
  | string
  | {
      text: string;
      action?: { label: string; onClick: () => void; busy?: boolean };
    };

export function StartScanCta({
  onStart,
  disabled,
  busy,
  error,
}: {
  onStart: () => void;
  disabled?: boolean;
  busy?: boolean;
  error?: ScanCtaError | null;
}) {
  const { t } = useI18n();
  const errText = typeof error === "string" ? error : error?.text ?? null;
  const action = typeof error === "object" && error ? error.action : undefined;
  return (
    <div className="start-cta" data-tour="scan-cta">
      <div className="start-cta__row">
        <p className="start-cta__title">{t("scan.startCtaTitle")}</p>
        <button
          type="button"
          className="start-cta__button"
          onClick={onStart}
          disabled={disabled || busy}
        >
          {busy ? t("scan.startCtaBusy") : t("scan.startCta")}
        </button>
      </div>
      {errText ? (
        <p className="start-cta__error">
          <span>{errText}</span>
          {action ? (
            <>
              {" "}
              <button
                type="button"
                className="start-cta__error-link"
                onClick={action.onClick}
                disabled={action.busy}
              >
                {action.label}
              </button>
            </>
          ) : null}
        </p>
      ) : null}
    </div>
  );
}
